import { Banner, Button, Card, Page, Text } from '@shopify/polaris';
import { MetricCard } from '../components/MetricCard';
import { getSyncStatusLabel } from '../lib/syncLabels';

function formatDateTime(value?: string | null) {
  if (!value) return '—';
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? '—' : date.toLocaleString('uk-UA');
}

function findCard(overview: any, key: string) {
  return (overview?.cards || []).find((card: any) => card.key === key);
}

export function OverviewPage({
  overview,
  onRefreshOverview,
  overviewLoading = false,
  overviewRefreshError = '',
  overviewUpdatedAt = null,
}: any) {
  return (
    <Page
      title="Огляд"
      subtitle="Живий стан інтеграції без дев-термінів"
      primaryAction={{ content: 'Оновити', onAction: onRefreshOverview, loading: overviewLoading }}
    >
      {!overview ? (
        <Card>
          <div className="admin-empty-state">
            <Text as="p" variant="bodyMd">Завантажую оперативний стан...</Text>
          </div>
        </Card>
      ) : (
        <div className="admin-stack">
          {overviewRefreshError ? (
            <Banner tone="warning" title="Огляд не оновився">
              <p>Показуємо останній відомий стан. Технічна причина: {overviewRefreshError}</p>
            </Banner>
          ) : null}

          <Text as="p" variant="bodySm" tone="subdued">
            Дані оновлено: {formatDateTime(overviewUpdatedAt || overview.generatedAt)}
          </Text>

          <div className="admin-grid admin-grid--metrics">
            {(overview.cards || []).map((card: any) => (
              <MetricCard
                key={card.key}
                label={card.label}
                value={card.summary || '—'}
                summary={card.lastCompletedAt ? `Останнє оновлення: ${formatDateTime(card.lastCompletedAt)}` : undefined}
                status={card.status}
              />
            ))}
          </div>

          <div className="admin-grid admin-grid--two">
            <Card>
              <div className="admin-stack">
                <div className="admin-section-head">
                  <Text as="h2" variant="headingMd">Останні синхронізації</Text>
                  <Button onClick={onRefreshOverview} loading={overviewLoading}>Оновити</Button>
                </div>
                <div className="admin-table-wrap">
                  <table className="admin-table">
                    <thead>
                      <tr>
                        <th>Статус</th>
                        <th>Початок</th>
                        <th>Завершення</th>
                        <th>Оброблено</th>
                        <th>Помилки</th>
                      </tr>
                    </thead>
                    <tbody>
                      {(overview.recentSyncHistory || []).map((entry: any, index: number) => {
                        const status = getSyncStatusLabel(entry.status);
                        return (
                        <tr key={`${entry.startedAt}-${index}`}>
                          <td title={status.description}>{status.label}</td>
                          <td>{formatDateTime(entry.startedAt)}</td>
                          <td>{formatDateTime(entry.completedAt)}</td>
                          <td>{entry.itemsProcessed}</td>
                          <td>{entry.itemsFailed}</td>
                        </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </div>
            </Card>

            <Card>
              <div className="admin-stack">
                <Text as="h2" variant="headingMd">Що робити далі</Text>
                <div className="admin-note-list">
                  <div className="admin-note-item">
                    <Text as="p" variant="bodyMd">1С: {findCard(overview, 'onec')?.summary || '—'}</Text>
                  </div>
                  <div className="admin-note-item">
                    <Text as="p" variant="bodyMd">LiqPay: {findCard(overview, 'liqpay')?.summary || '—'}</Text>
                  </div>
                  <div className="admin-note-item">
                    <Text as="p" variant="bodyMd">Повна синхронізація: {findCard(overview, 'full_sync')?.summary || getSyncStatusLabel(overview.lastSync?.full?.status).label}</Text>
                  </div>
                  <div className="admin-note-item">
                    <Text as="p" variant="bodyMd">Черга замовлень: {findCard(overview, 'queued_orders')?.summary || '—'}</Text>
                  </div>
                </div>
              </div>
            </Card>
          </div>
        </div>
      )}
    </Page>
  );
}
